import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { ISwapRequestResponse } from "..";
import moment from "moment";

interface CardShiftListProps extends ISwapRequestResponse {
  onCancel: (id: string) => void;
}

const CardShiftList = ({
  _id,
  createdAt,
  day,
  month,
  year,
  shift,
  onCancel,
}: CardShiftListProps) => {
  const [cancelling, setCancelling] = useState(false);

  const capitalizeFirstLetter = (val: string) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  };

  const handleCancel = async () => {
    setCancelling(true);
    await onCancel(_id);
    setCancelling(false);
  };

  return (
    <div className="flex flex-wrap items-center bg-white rounded-[8px] overflow-hidden mb-[4px] 2xl:text-base text-moon-14">
      <div className="2xl:flex-[0_0_246px] flex-[0_0_200px]  p-[17px_16px]">
        <p>{moment(new Date(createdAt)).format("DD MMMM yyyy")}</p>
      </div>
      <div className="2xl:flex-[0_0_246px] flex-[0_0_200px]  p-[17px_16px]">
        <p>{moment(new Date(year, month - 1, day)).format("DD MMMM yyyy")}</p>
      </div>
      <div className="2xl:flex-[0_0_246px] flex-[0_0_200px]  p-[17px_16px]">
        <div
          className={`inline-flex items-center gap-[5px] font-semibold 2xl:text-moon-16 ${
            shift === "day" ? "text-krillin" : "text-bulma"
          }`}
        >
          {shift === "day" ? (
            <span className="2xl:text-moon-18">
              <Icon icon="uil:sun" />
            </span>
          ) : (
            <span className="2xl:text-moon-18">
              <Icon icon="uil:moon" />
            </span>
          )}
          {capitalizeFirstLetter(shift)}
        </div>
      </div>
      <div className="flex-1 p-[17px_16px] flex justify-end">
        <button
          onClick={handleCancel}
          disabled={cancelling}
          className="inline-flex items-center gap-1 text-moon-14 text-red-500 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <Icon icon="uil:times-circle" className="text-moon-16" />
          {cancelling ? "Cancelling..." : "Cancel"}
        </button>
      </div>
    </div>
  );
};

export default CardShiftList;
